// extracted by mini-css-extract-plugin
module.exports = {"article":"styles_article__OqCS3","image":"styles_image__ME8gy"};